<template>
    <nav class="top-bar navbar-fixed-top">
        <div class="logo-area">
            <div class="logo float-left">
                <a href="#" @click.prevent="goToHome">
                    <img :alt="azureName" class="full-logo"
                         :src="`/img/${azureKey}/logo.svg`" height="50" width="150">
                    <img :alt="azureName" class="logo-short"
                         :src="`/img/${azureKey}/logo_only.svg`" height="50" width="50">
                </a>
            </div>
        </div>

        <div class="top-bar-right float-right">
            <div class="logged-user" v-if="isLoggedIn">

                <div class="btn-group">
                    <a href="#" class="btn btn-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
                       data-bs-display="static">

                        <span class="name">
                            {{ username }}
                        </span>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                            <a @click="logOut" class="dropdown-item"><i class="fas fa-power-off"></i><span class="text">Logout</span></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { useRouter } from "vue-router";
import { getFullUserName, logOut, userState } from "@/stores/user";
import { state as azureAd } from "@/stores/azure-ad";
import { computed } from "vue";

export default {
    name: "Header",
    setup() {
        const router = useRouter();

        return {
            isLoggedIn: computed(() => userState.isLoggedIn),
            username: computed(() => getFullUserName()),
            goToHome: () => router.push('/'),
            azureKey: computed(() => azureAd.key),
            azureName: computed(() => azureAd.name),
            logOut
        }
    }
}
</script>

<style scoped lang="scss">
.top-bar {
    .logo {
        margin-left: 10px;

        @media (max-width: 660px) {
            .logo-short {
                display: inline-block;
            }

            .full-logo {
                display: none;
            }
        }

        @media (min-width: 661px) {
            .logo-short {
                display: none;
            }

            .full-logo {
                display: inline-block;
            }
        }
    }

    .logged-user {
        padding-top: 5px;

        ul {
            li {
                a {
                    display: block;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>